import React, {FC} from 'react';

import {Colors, MediaQuery, Text} from '@optimaxdev/design-system';
import {useSelector} from 'react-redux';

import {useMediaQuery} from 'react-responsive';

import {getOrderDetails} from 'desktop/pages/success/selectorsV2';

import s from './successHeader.scss';

type PropsType = {
    shipmentInfo: string;
};

/**
 * Header component for TYP glasses
 */
export const SuccessHeader: FC<PropsType> = ({shipmentInfo}) => {
    const isSmallScreen = useMediaQuery(MediaQuery.sm);
    const {shipping_address: shippingAddress} = useSelector(getOrderDetails);

    const words = shipmentInfo.trim().split(' ');
    const lastTwoWords = words.slice(-2).join(' ');
    const restOfMessage = words.slice(0, -2).join(' ');

    return (
        <div className={s.title}>
            <Text
                color={Colors.blueCharcoal}
                lineHeight={isSmallScreen ? '34px' : '38px'}
                size={isSmallScreen ? '24px' : '28px'}
                bold
            >
                {isSmallScreen ? (
                    <>
                        Awesome! Thank you {shippingAddress?.firstname}, your
                        <br />
                        order is in the works.
                    </>
                ) : (
                    <>
                        Awesome! Thank you {shippingAddress?.firstname},
                        <br />
                        your order is in the works.
                    </>
                )}
            </Text>
            <Text color={Colors.limedSpruce} lineHeight="24px" size="16px">
                We&apos;ve sent you a confirmation email to {shippingAddress?.email}
            </Text>
            {Boolean(shipmentInfo) && (
                <Text color={Colors.limedSpruce} lineHeight="24px" size="16px">
                    {restOfMessage} <strong>{lastTwoWords}</strong>
                </Text>
            )}
        </div>
    );
};
